import styled from 'styled-components'

export const OrdenacaoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  .circle {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: red;
    border: 2px solid black;

    span {
      font-size: 10px;
    }
  }

  .linha {
    height: 25px;
    border: 2px dashed red; /* Cor verdinha pra ficar simpática */
    border-radius: 8px;
    margin-left: 5px;
  }
`
